const parseSize = (value) => {
  if (value === undefined || value === null) return 0;
  const parsed = Number.parseFloat(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const getNodeSize = (svgNode) => {
  const rect = svgNode.getBoundingClientRect ? svgNode.getBoundingClientRect() : null;
  const width = rect?.width || parseSize(svgNode.getAttribute('width')) || svgNode.clientWidth || 0;
  const height =
    rect?.height || parseSize(svgNode.getAttribute('height')) || svgNode.clientHeight || 0;
  return { width, height };
};

const getRelativePosition = (svgNode, container) => {
  const nodeRect = svgNode.getBoundingClientRect ? svgNode.getBoundingClientRect() : null;
  const containerRect = container?.getBoundingClientRect ? container.getBoundingClientRect() : null;
  return {
    x: Math.max(0, (nodeRect?.left || 0) - (containerRect?.left || 0)),
    y: Math.max(0, (nodeRect?.top || 0) - (containerRect?.top || 0)),
  };
};

const composeSvgNodes = (svgNodes, container) => {
  if (!svgNodes.length) return '';
  if (svgNodes.length === 1) return svgNodes[0].outerHTML || '';

  const containerRect = container?.getBoundingClientRect ? container.getBoundingClientRect() : null;
  let composedWidth = containerRect?.width || 0;
  let composedHeight = containerRect?.height || 0;

  const layers = svgNodes
    .map((svgNode) => {
      const { width, height } = getNodeSize(svgNode);
      if (!width || !height) return null;
      const { x, y } = getRelativePosition(svgNode, container);
      composedWidth = Math.max(composedWidth, x + width);
      composedHeight = Math.max(composedHeight, y + height);
      return `<g transform="translate(${x},${y})">${svgNode.outerHTML || ''}</g>`;
    })
    .filter(Boolean)
    .join('');

  if (!layers) return '';

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${Math.ceil(
    composedWidth
  )}" height="${Math.ceil(composedHeight)}" viewBox="0 0 ${Math.ceil(composedWidth)} ${Math.ceil(
    composedHeight
  )}">${layers}</svg>`;
};

export const getQuestionSvgPayload = (questionId, doc = document) => {
  const container = doc.querySelector(`#chart-id-${questionId}`);
  if (!container) return [];

  const svgNodes = Array.from(container.querySelectorAll('svg')).filter((svgNode) => {
    const { width, height } = getNodeSize(svgNode);
    return width > 0 && height > 0;
  });

  if (!svgNodes.length) return [];
  return [composeSvgNodes(svgNodes, container)].filter(Boolean);
};

export { composeSvgNodes };
